import { Record } from 'immutable';

const UnitRecord = Record({
  id: undefined,
  name: undefined,
  orderingSequence: undefined,
});

class Unit extends UnitRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`]; // stringify
    default:
      return [key, val];
  }
};

Unit.create = (data) =>
  new Unit(data).mapEntries(reviver);

export default Unit;



// WEBPACK FOOTER //
// ./data/Units/model/model.js